// extracted by mini-css-extract-plugin
export default {"content":"card_content__JCTnV","info":"card_info__fKTrJ","value":"card_value__1njp6","card":"card_card__KygNH","icon":"card_icon__D1b-w"};